/**
 * Deep-link handler for push notification tap actions.
 *
 * Backend sends: { type: string, lead_id: string } in the push data payload.
 *
 * type values and their destinations:
 *   lead_assigned      → /workspace?lead_id=<id>   (telecaller opens the lead)
 *   lead_qualified     → /workspace?lead_id=<id>
 *   lead_lost          → /leads/<id>               (DP/IH review)
 *   od_discount_request → /discounts
 *   neg_conf_sent      → /negconf
 *   neg_conf_dispute   → /negative-confirmations   (DP/IH review disputed queue)
 *   reminder_due       → /leads/<id>               (telecaller calls back)
 */

import type { NavigateFunction } from 'react-router-dom'

export function handleDeepLink(
  type: string | undefined,
  leadId: string | undefined,
  navigate: NavigateFunction,
): void {
  if (!type) return

  switch (type) {
    case 'lead_assigned':
    case 'lead_qualified':
      navigate(leadId ? `/workspace?lead_id=${leadId}` : '/workspace')
      break
    case 'lead_lost':
      navigate(leadId ? `/leads/${leadId}` : '/leads/history')
      break
    case 'od_discount_request':
      navigate('/discounts')
      break
    case 'neg_conf_sent':
      navigate('/negconf')
      break
    case 'neg_conf_dispute':
      navigate('/negative-confirmations')
      break
    case 'reminder_due':
      navigate(leadId ? `/leads/${leadId}` : '/workspace')
      break
    default:
      break
  }
}
